(function () {
  'use strict';

  var MQ = '(max-width: 768px)';
  var REDUCE = '(prefers-reduced-motion: reduce)';

  function init(root) {
    var list = root.querySelector('.store-claims__list');
    var items = root.querySelectorAll('.store-claims__item');
    if (!list || items.length < 2) return;

    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var speed = parseInt(root.getAttribute('data-speed'), 10);
    if (!speed || speed < 1) speed = 4;

    var index = 0;
    var timer = null;

    function apply() {
      var mobile = window.matchMedia(MQ).matches;
      if (!mobile) {
        list.style.transform = '';
        return;
      }
      list.style.transform = 'translateX(-' + index * 100 + '%)';
    }

    function next() {
      index = (index + 1) % items.length;
      apply();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay) return;
      if (window.matchMedia(REDUCE).matches) return;
      if (!window.matchMedia(MQ).matches) return;
      timer = setInterval(next, speed * 1000);
    }

    window.addEventListener(
      'resize',
      function () {
        if (!window.matchMedia(MQ).matches) index = 0;
        apply();
        start();
      },
      { passive: true }
    );

    apply();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-section-type="store-claims"]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
